import users from './user'
import app from "@/store/state/app"
import pagination from './pagination'

export default {
  users,
  app,
  pagination,
}